import JumboCardQuick from '@jumbo/components/JumboCardQuick';
import { Avatar, Box, Chip, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import React, { useState } from 'react';
import LoadingPopUp from '../LoadingPopup';
import config from 'config';
import { getLocaleDateTime, getUserFullName } from 'app/utils/appHelpers';
import { useSelector } from 'react-redux';
function PreviewSuggestionListCard({ mainData, meetingUsers }) {
    const [suggestionList] = useState(mainData);
    const [loading] = useState(false);
    const userList = useSelector(state => state.user.data);
    
    return (
        <React.Fragment>
            <LoadingPopUp open={loading} />
            {!loading && (
                <JumboCardQuick
                    title={
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Box sx={{ color: 'white' }}>Öneriler</Box>
                            <Chip label={`${suggestionList.length} Öneri`} size="small" sx={{ color: 'white' }} />
                        </Box>
                    }
                    headerSx={{ borderBottom: 1, borderBottomColor: "divider", backgroundColor: 'error.main' }}
                    wrapperSx={{ p: 0, backgroundColor: 'error.main' }}
                >
                    <Box sx={{ borderBottom: "1px solid #ccc", mb: 1 }}>
                        <Table >
                            <TableHead>
                                <TableRow sx={{ backgroundColor: '#f5f7fa' }}>
                                    <TableCell sx={{ width: "30%", textAlign: "left" }}>
                                        <Box sx={{ fontWeight: 500 }}>
                                            Üye
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={{ width: "70%", textAlign: "left" }}>
                                        <Box sx={{ fontWeight: 500 }}>
                                            Öneri
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {suggestionList.map((suggestion, index) => (
                                    <TableRow
                                        key={index}
                                        sx={{
                                            '&:hover': {
                                                backgroundColor: '#f1f5f9'
                                            },
                                            backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc'
                                        }}
                                    >
                                        <TableCell>
                                            {(() => {

                                                const user = meetingUsers.find(item => item.userId === suggestion.userId);
                                                const userInfo = userList.find(item => item.id === suggestion.userId);

                                                return (
                                                    <Box
                                                        key={suggestion.userId}
                                                        sx={{

                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: 1,
                                                        }}
                                                    >
                                                        <Avatar
                                                            alt={user ? user.name : ""}
                                                            src={
                                                                user && user.profileImageUrl
                                                                    ? `${config.userAuthApiUrl}${user.profileImageUrl}`
                                                                    : undefined
                                                            }
                                                            onError={(e) => {
                                                                e.target.onerror = null;
                                                                e.target.src =
                                                                    config.userAuthApiUrl + config.defaultProfileImageUrl;
                                                            }}
                                                        />
                                                        <Typography variant="body2" sx={{ lineHeight: 1 }}>
                                                            {getUserFullName(userInfo)} ({user.inst})
                                                            {user.memberRole === "Başkan" || user.memberRole === "Başkan Yrd" ? (
                                                                <span style={{ fontStyle: "italic" }}>{" "}  ({user.memberRole})</span>
                                                            ) : null}
                                                            {user.acting === "Vekaleten" ? (
                                                                <span style={{ fontStyle: "italic" }}>{" "}  (V.)</span>
                                                            ) : null}
                                                            {user.attendanceStatus === 0 || user.attendanceStatus === '0' ? (
                                                                <span style={{ fontStyle: "italic" }}>{" "}  ({"Katılmadı"})</span>
                                                            ) : null}
                                                        </Typography>
                                                    </Box>
                                                );
                                            })()}
                                        </TableCell>
                                        <TableCell>
                                            <Box sx={{ color: '#334155' }}>
                                                {suggestion.info} <span style={{ fontStyle: "italic" }}> ( {getLocaleDateTime(suggestion.pdate)})</span>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Box>
                </JumboCardQuick>
            )}
        </React.Fragment>
    );
}

export default PreviewSuggestionListCard;
